import { Link } from "react-router-dom";
import { apiAsset } from "../../commons/inFormTypes";
export const truncate = (str, len) => {
    if (str?.length > len && str?.length > 0) {
      let new_str = str + " ";
      new_str = str?.substr(0, len);
      new_str = str?.substr(0, new_str.lastIndexOf(" "));
      new_str = new_str.length > 0 ? new_str : str?.substr(0, len);
      return new_str + "...";
    }
    return str;
  };
  const ImportantNewsCard = ({ newsPic, newsTitle, newsDate, newsTime, navLink }) => {
    return (
        <div className="rounded-md shadow-3xl pb-[10px] pt-[15px] px-[8%] h-full flex flex-col justify-between">
            <div>
                <img
                    loading="lazy"
                    className="w-[100%] h-[160px] rounded-md object-cover"
                    src={apiAsset+newsPic}
                    alt="تصویر"
                />
            </div>
            <div className="my-[10px] flex-grow">
                <Link to={navLink } className="text-[18px] font-IRANYekanExtra sm:text-[14px]">
                    {truncate(newsTitle, 60)}
                </Link>
            </div>
            <div className="flex justify-end items-start">
                <p className="text-[14px] font-IRANYekanNormal text-mainColor pl-1 border-l-[1px] border-lightGray">
                    {newsDate}
                </p>
                <p className="text-[14px] font-IRANYekanNormal text-mainColor mr-1">
                    {newsTime}
                </p>
            </div>
        </div>
    );
};

export default ImportantNewsCard;